import has from 'lodash/has';
import mapValues from 'lodash/mapValues';
import identify from "~/identify";

export function invalidateOptions(options) {
    return mapValues(options, (optionStatus) => {
        if(has(optionStatus, 'autocomplete')) {
            return {
                ...optionStatus,
                autocomplete: {
                    ...optionStatus.autocomplete,
                    status: identify.STATUS_INVALIDATED,
                    invalidated_at: Date.now()
                }
            }
        }

        return optionStatus;
    });
}

export default function invalidateLoadedModels(state, exclude = []) {
    let touchedModelNames = [];

    let ui = state.ui;

    state = {
        ...state,
        ui: {
            searchModels: mapValues(ui.searchModels, (model) => {
                return {
                    ...model,
                    results: {
                        ...model.results,
                        invalidated_at: Date.now(),
                        status: identify.STATUS_INVALIDATED,
                        loadedParams: null,
                        loadingParams: null,
                    },
                }
            }),

            ...state.ui,
            loadedModels: mapValues(ui.loadedModels, (model) => {
                let { modelId } = model;

                if(exclude.indexOf(modelId) > -1) {
                    return model;
                }

                touchedModelNames.push(model.modelName);

                return {
                    ...model,

                    results: {
                        ...model.results,
                        invalidated_at: Date.now(),
                        status: identify.STATUS_INVALIDATED,
                        loadedParams: null,
                        loadingParams: null,
                    },

                    itemData: {
                        ...model.itemData,
                        invalidated_at: Date.now(),
                        status: identify.STATUS_INVALIDATED,
                    }
                };
            })
        }
    };

    state = {
        ...state,
        models: mapValues(state.models, (model, modelName) => {
            if(touchedModelNames.indexOf(modelName) < 0) {
                return model;
            }

            return {
                ...model,
                invalidated_at: Date.now(),
                status: identify.STATUS_INVALIDATED,
            }
        })
    }

    return state;
}